import tinycolor from 'tinycolor2';

const COLORS = {
  light: {
    primary: '#FFFFFF',
    stain: '#EBF1F5',
    neutral: '#e9edf4',
    secondary: '#A7B6C2',
    light: '#e6eaf2'
  },
  gray: {
    primary: '#eff0f1',
    stain: '#b3c0d2',
    neutral: '#8691A6',
    secondary: '#556074',
    light: '#f6f7fb'
  },
  dark: {
    primary: '#202635',
    stain: '#182026',
    neutral: '#293742',
    secondary: '#556074',
    light: '#48494c'
  },
  primary: {
    primary: '#e74e4e',
    stain: '#fa6666',
    neutral: '#cd453d',
    secondary: '#aa342c',
    light: '#ffd9cf'
  },
  secondary: {
    primary: '#1d9fb8',
    stain: '#61bccd',
    neutral: '#0494b0',
    secondary: '#146f81',
    light: '#edfafc'
  },
  success: {
    primary: '#2dbd6f',
    stain: '#15B371',
    neutral: '#0D8050',
    secondary: '#0F9960',
    light: '#EBF8F0'
  },
  danger: {
    primary: '#e74e4e',
    stain: '#fa6666',
    neutral: '#cd453d',
    secondary: '#aa342c',
    light: '#fdf7f7'
  },
  warning: {
    primary: '#f5a500',
    stain: '#ffb829',
    neutral: '#D99E0B',
    secondary: '#BF8C0A',
    light: '#fff7e9'
  }
};

export default COLORS;
